<template>
  <div class="details-box">
    <div class="details">
      <div class="user">
        <div class="user-info">
          <!-- <img class="avater" v-if="user.avatar" v-lazy="user.avatar" /> -->
          <img class="avater" v-if="user.avatar" v-lazy="`${user.real_avatar!=='null' && user.real_avatar!=='' ? user.real_avatar:avatar}?x-oss-process=image/resize,m_fill,w_72,h_72`"/>
          <img class="avater" v-else src="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/default-profile.png?x-oss-process=image/resize,m_fill,w_72,h_72"/>
          <div class="info-details">
            <span class="name">{{user.fullname !== '' && user.fullname!='null' ? user.fullname : user.nickName}}</span>
            <span class="time">{{getTimes}}发起</span>
          </div>
        </div>
        <div class="tools">
          <img
            v-if="platform !== 'notInDingTalk'"
            @click="getShareContent"
            src="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/share.svg"
            alt
          />
          <img
            @click="updateShowMore"
            src="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/more.svg"
            alt
          />
        </div>
      </div>
      <div class="box">
        <h4>{{title ? title : `${user.fullname !== '' && user.fullname!='null' ? user.fullname : user.nickName}发起的召集令`}}</h4>
        <span class="limit">{{ limit ? `人数限制 ${limit}人` :  '无人数限制'}}</span>
        <div class="border" />
        <div class="desc-item">
          <span class="icon iconfont">&#xe68d;</span>
          <span>{{getTimeStr()}}</span>
        </div>
        <div class="desc-item">
          <span class="icon iconfont">&#xe68e;</span>
          <span>{{address}}</span>
        </div>
        <div class="desc">
          <img src="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/QuotationMarks.svg" />
          <span v-html="desc"></span>
        </div>
        <div class="total" v-if="participants.length">
          <div class="avater-box">
            <img
              v-for="item of participants"
              :key="item.id"
              v-lazy="`${item.user.real_avatar !=='' && item.user.real_avatar !== 'null' ? item.user.real_avatar:item.user.avatar ? item.user.avatar: 'http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/default-profile.png' }?x-oss-process=image/resize,m_fill,w_88,h_88`"
            />
          </div>
          <span class="total-desc">{{joinCount}}人已报名</span>
        </div>
      </div>
      <div class="tip">注：如报名后无法赴约，请记得提前来取消哦~</div>
      <div class="footer">
        <button class="expire" v-if="status === 0">已取消</button>
        <button class="expire" v-if="status === 2">已过期</button>
        <template v-else-if="Object.is(status, 1) && judgeButton">
          <button @click="edit">编辑修改</button>
          <button class="query-list" @click="goSignList">查看名单</button>
          <!-- <button class="cancel" @click="cacelSignUp">取消召集</button> -->
        </template>
        <!-- <button v-else-if="Object.is(status, 1) && !judgeButton && !isJoin" @click="deleteSignUp">取消报名</button> -->
        <button v-else-if="Object.is(status, 1) && !judgeButton && !isJoin " @click="signUpPre">立即报名</button>
        <button
          v-else-if="Object.is(status, 1) && !judgeButton && isJoin"
          @click="deleteSignUp"
        >取消报名</button>
      </div>
      <Tip v-if="show" :label="tipLabel" />
      <!-- <van-popup v-model="showMore" round position="bottom" >
      <div @click="goCreate" class="create">我有活动，去发召集令</div>
      <div :class="{ cancels: true, disable: (!Object.is(status, 1) || judgeButton || !isJoin) }" @click="deleteSignUp">取消报名</div>
      <div @click="goList" class="more">查看更多活动</div>
      </van-popup>-->
      <AnimationModel v-if="showMore" v-model="showMore">
        <template v-slot:content>
          <div class="buttons">
            <div @click="goCreate" class="create">我有活动，去发召集令</div>
            <div
              v-if="Object.is(status, 1) && judgeButton"
              :class="{ cancels: true, disable: (Object.is(status, 1) && !judgeButton) }"
              @click="cacelSignUp"
            >取消召集</div>
            <div @click="goList" class="more">查看更多活动</div>
          </div>
        </template>
      </AnimationModel>
    </div>
    <div class="message-box" :style="{ 'margin-bottom': isAndroid ? '50px' : '130px' }">
      <DynamicMessage
        v-for="item of messages"
        @click.native="setContent(item)"
        @thumbsUp="childthumbsUp(item)"
        :key="item.id"
        v-bind="item"
      />
    </div>
    <div class="send-message">
      <input v-model="content" :placeholder="placeholder"/>
      <button @click="createMessage"><img :src="`http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/send-plane${content ? '-block' : ''}.svg`"/></button>
    </div>
    <Confirm title="确认报名" @click="isEdit = false" v-if="showConfirm" @cancel="showConfirm = false" @confirm="signUp">
      <template v-slot:content>
        <span>为确保召集者能够与您取得联系，请确认您有效的手机号码：</span>
      </template>
      <template>
        <div class="phone-box"><span>{{phoneNumber}}</span><span @click.stop="isEdit = true" class="edit">修改</span></div>
      </template>
      <template v-slot:hidden>
        <div v-if="isEdit" class="phone-input">
          <input @click.stop="() => {}" type="number" placeholder="请输入手机号码" v-model="prePhoneNumber"/>
          <button @click.stop="confirm">确认</button>
        </div>
      </template>
    </Confirm>
    <SetNickName :show="showSetNickName" @close="showSetNickName = false"/>
  </div>
</template>
<script>
import Tip from '../../../components/Tip'
import dd from 'DD'
import { get, post, _delete } from '../../../utils/request'
import { formateRegexToDate, formateDateTostr, getBeforeTimeStr } from '../../../utils/date'
import { get as getUser } from '../../../utils/token'
import AnimationModel from '../../../components/AnimationModel'
import { isAndroid } from '../../../utils/utils'
import DynamicMessage from './DynamicMessage'
import Mixins from '../../../minixs/ddMixis'
import Confirm from '../../../components/Confirm'
import AuthMixis from '../../../minixs/auth'
export default {
  mixins: [Mixins, AuthMixis],
  components: {
    Tip,
    AnimationModel,
    DynamicMessage,
    Confirm
  },
  activated () {
    this.getDetails()
    this.getMessages()
  },
  mounted () {
    // this.getDetails()
    // this.getMessages()
  },
  data () {
    return {
      prePhoneNumber: '',
      phoneNumber: '',
      showConfirm: false,
      isEdit: false,
      isAndroid: isAndroid(),
      showMore: false,
      tipLabel: '你已经成功报名！',
      show: false,
      platform: dd.env.platform,
      address: '',
      assembleTime: '',
      createTime: '',
      id: 0,
      joinCount: 0,
      isJoin: false,
      limit: 500,
      desc: '',
      participants: [],
      status: 1,
      title: '',
      user: {
        avatar: '',
        id: 12,
        isForbidden: false,
        nickName: '',
        signName: '',
        username: ''
      },
      content: '',
      placeholder: '说点什么吧 ~',
      messages: [
      ]
    }
  },
  methods: {
    goSignList () {
      const { id } = this.$route.params
      this.$router.push({
        path: `/exerland/singUpList/${id}`
      })
    },
    setContent (item) {
      this.placeholder = `回复@ ${item.user.nickName}`
    },
    getMessages () {
      const { id } = this.$route.params
      const user = getUser('user')
      const promsie = get({
        url: `/call/talesComment/${user.id}/${id}`
      })
      promsie.then(res => {
        const { data: { code, detail: { list } } } = res
        if (Object.is(code, 200)) {
          this.messages = list
        }
      })
    },
    createMessage () {
      if (!this.content) {
        return
      }
      const user = getUser('user')
      const { id } = this.$route.params
      const promsie = post({
        url: `/call/talesComment/${user.id}/${id}`,
        data: {
          content: this.content
        }
      })
      promsie.then(res => {
        const { data: { code } } = res
        if (Object.is(code, 200)) {
          this.content = ''
          this.placeholder = '说点什么吧 ~'
          this.getMessages()
        }
      })
    },
    childthumbsUp (item) {
      item.isUp = !item.isUp
      let count = item.upCount
      if (item.isUp) {
        ++count
      } else {
        --count
      }
      item.upCount = count
    },
    signUpPre () {
      const flag = this.judgeUserNickName()
      if (flag) {
        return
      }
      this.showConfirm = true
      const user = getUser('user')
      this.phoneNumber = user.phoneNumber
      this.prePhoneNumber = ''
    },
    confirm () {
      this.isEdit = false
      if (this.prePhoneNumber) {
        this.phoneNumber = this.prePhoneNumber
      }
      this.prePhoneNumber = ''
    },
    signUp () {
      this.confirm()
      const user = getUser('user')
      const { id } = this.$route.params
      const promise = post({
        url: `/call/sign/${id}`,
        data: {
          userId: user.id,
          talesId: id,
          phoneNumber: this.phoneNumber
        }
      })
      promise.then(res => {
        this.showConfirm = false
        const {
          status,
          data: { message }
        } = res
        if (Object.is(status, 200)) {
          this.show = true
          this.tipLabel = message
          this.getDetails()
          setTimeout(() => {
            this.show = false
          }, 1000)
        }
      })
    },
    deleteSignUp () {
      if (!Object.is(this.status, 1) || this.judgeButton || !this.isJoin) {
        return
      }
      const user = getUser('user')
      const { id } = this.$route.params
      const promise = _delete({
        url: `/call/sign/${id}`,
        data: {
          userId: user.id,
          talesId: id
        }
      })
      promise.then(res => {
        const { status } = res
        if (Object.is(status, 200)) {
          this.show = true
          this.tipLabel = '你已经取消报名！'
          this.getDetails()
          setTimeout(() => {
            this.show = false
          }, 1000)
        }
      })
    },
    cacelSignUp () {
      if (!Object.is(this.status, 1) || !this.judgeButton) {
        return
      }
      const user = getUser('user')
      const { id } = this.$route.params
      const promise = post({
        url: `/call/cancel/${id}/${user.id}`
      })
      promise.then(res => {
        /* eslint-disable-next-line */
        console.log("cacelSignUp", res);
        this.getDetails()
      })
    },
    getTimeStr () {
      return formateDateTostr(
        formateRegexToDate(this.assembleTime),
        'MM月DD日 星期WEEK HH:mm'
      )
    },
    updateShow () {
      this.show = !this.show
    },
    updateShowMore () {
      this.showMore = !this.showMore
    },
    getDetails () {
      const user = getUser('user')
      const { id } = this.$route.params
      const promise = get({
        url: `/call/talesDetail/${id}/${user.id}`
      })
      promise.then(res => {
        const {
          status,
          data: { detail }
        } = res
        if (Object.is(status, 200)) {
          Object.assign(this, detail)
        }
      })
    },
    goCreate () {
      this.updateShowMore()
      this.$router.push({
        path: '/exerland/createSummoningOrder'
      })
    },
    edit () {
      this.$router.push({
        path: `/exerland/createSummoningOrder?id=${this.id}`
      })
    },
    goList () {
      this.updateShowMore()
      this.$router.push({
        path: '/exerland/bbs/dynamic?active=SummoningOrder'
      })
    }
  },
  computed: {
    getTimes () {
      return getBeforeTimeStr(this.createTime)
    },
    judgeButton () {
      const user = getUser('user')
      return Object.is(user.id, this.user.id)
    }
  },
  watch: {
    phoneNumber (value) {
      if (!value) {
        const user = getUser('user')
        this.phoneNumber = user.phoneNumber
      } else if (value.length > 11) {
        this.phoneNumber = value.substring(0, 11)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../assets/font/iconfont.css";
.details-box {
  height: 100vh;
  overflow-y: scroll;
  position: relative;
  // background: #fff;
  .details {
    padding: 22px 16px;
    .user {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .user-info {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 68px;
        background: rgba(245, 245, 245, 1);
        border-radius: 8px;
        box-sizing: border-box;
        padding: 16px;
        .avater {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          margin-right: 6px;
        }
        .info-details {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .name {
            font-size: 16px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: rgba(51, 51, 51, 1);
            line-height: 16px;
            display: block;
            margin-bottom: 4px;
          }
          .time {
            font-size: 11px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(60, 60, 67, 0.6);
            line-height: 12px;
          }
        }
      }
      .tools {
        img {
          width: 44px;
          height: 44px;
          display: inline-block;
          &:last-child {
            margin-left: 16px;
          }
        }
      }
    }
    .box {
      width: 100%;
      box-sizing: border-box;
      padding: 32px 32px 32px 17px;
      border-radius: 8px;
      border: 2px solid rgba(51, 51, 51, 1);
      margin-top: 16px;
      h4 {
        font-size: 20px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: rgba(0, 0, 0, 1);
        line-height: 28px;
        margin-left: 10px;
      }
      .limit {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(136, 136, 136, 1);
        line-height: 17px;
        display: block;
        margin-top: 16px;
        margin-left: 10px;
      }
      .border {
        width: calc(100% - 10px);
        height: 2px;
        background: rgba(229, 229, 229, 1);
        margin-top: 12px;
        margin-bottom: 24px;
        margin-left: 10px;
      }
      .desc-item {
        margin-bottom: 23px;
        margin-left: 10px;
        .iconfont {
          font-size: 16px;
          margin-right: 12px;
        }
        span {
          font-size: 14px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: rgba(51, 51, 51, 1);
          line-height: 20px;
        }
      }
      .desc {
        display: flex;
        justify-content: flex-start;
        img {
          width: 21.39px;
          height: 18.72px;
          margin-right: 14px;
        }
        span {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          line-height: 20px;
        }
      }
      .total {
        margin-top: 32px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .avater-box {
          img {
            display: inline-block;
            width: 40px;
            height: 40px;
            margin-right: 8px;
            border-radius: 50%;
          }
        }
        .total-desc {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
        }
      }
    }
    .tip {
      width: 100%;
      text-align: center;
      font-size: 11px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(136, 136, 136, 1);
      line-height: 16px;
      margin-top: 32px;
    }
    .footer {
      width: 100%;
      margin-top: 22px;
      margin-bottom: 16px;
      display: flex;
      justify-content: space-around;
      button {
        width: 132px;
        height: 44px;
        background: rgba(0, 0, 0, 1);
        box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.28);
        border-radius: 4px;
        box-sizing: border-box;
        font-size: 17px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
        border: none;
        outline: none;
      }
      .cancel {
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.1);
        color: rgba(0, 0, 0, 1);
      }
      .expire {
        background: rgba(216, 216, 216, 1);
        color: rgba(255, 255, 255, 1);
      }
      .query-list {
        background:rgba(255,255,255,1);
        color:rgba(0,0,0,1);
      }
    }
    .buttons {
      width: 100%;
      background: #fff;
      border-radius: 16px 16px 0px 0px;
      width: 100%;
      .create {
        width: 100%;
        height: 58px;
        text-align: center;
        line-height: 58px;
        border-bottom: 2px solid #e5e5e5;
      }
      .cancels {
        width: 100%;
        height: 58px;
        text-align: center;
        line-height: 58px;
        border-bottom: 4px solid #e5e5e5;
      }
      .disable {
        color: rgba(136, 136, 136, 1);
      }
      .more {
        width: 100%;
        height: 58px;
        text-align: center;
        line-height: 58px;
      }
    }
  }
  .message-box {
    width: 100%;
    box-sizing: border-box;
  }
  .send-message {
    width: 100%;
    height: 50px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px -2px 4px 0px rgba(0, 0, 0, 0.04);
    padding: 7px 16px;
    box-sizing: border-box;
    position: fixed;
    bottom: 0;
    left: 0;
    display: flex;
    input {
      width: 100%;
      background: rgba(245, 245, 245, 1);
      padding: 7px 17px;
      box-sizing: border-box;
      border-radius: 18px;
      border: none;
      outline: none;
      &::-webkit-input-placeholder {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(136, 136, 136, 1);
        line-height: 22px;
      }
    }
    button {
      white-space: nowrap;
      border: none;
      outline: none;
      font-size: 14px;
      background: #fff;
      padding-left:16px;
      img {
        width: 33px;
        height: 33px;
      }
    }
  }
  .phone-box {
      margin-top: 8px;
      span {
        font-size:17px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(51,51,51,1);
        line-height:24px;
        display: inline-block;
      }
      .edit {
        color:rgba(87,107,148,1);
        margin-left: 11px;
        font-size: 14px;
        font-weight: 400;
      }
    }
    .phone-input {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height:50px;
    background:rgba(255,255,255,1);
    box-shadow:0px -2px 4px 0px rgba(0,0,0,0.04);
    box-sizing: border-box;
    padding: 16px 7px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    input {
      width: 275px;
      height: 36px;
      background:rgba(245,245,245,1);
      border-radius:18px;
      padding: 7px 17px;
      border: none;
      outline: none;
      box-sizing: border-box;
    }
    ::-webkit-input-placeholder {
      font-size:16px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(136,136,136,1);
    }
    button {
      display: inline-block;
      width:70px;
      height:36px;
      background:rgba(0,0,0,1);
      box-shadow:0px 2px 12px 0px rgba(0,0,0,0.28);
      border-radius:4px;
      font-size:14px;
      font-family:PingFangSC-Medium,PingFang SC;
      font-weight:500;
      color:rgba(255,255,255,1);
      line-height:20px;
      border: none;
      outline: none;
    }
  }
}
</style>
